import React, { useEffect, useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { getRefundRequest, sendEmailToProvider } from '../../../../redux/actions/refundAction';
import { getFileFromS3 } from '../../../../redux/actions/s3Action';
//
import { dateFormat } from '../../../../controllers/dataFormat';
// core component
import { Typography, Grid, IconButton, TableCell } from '@material-ui/core'
import MUIDataTable from "mui-datatables";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
// component
import Button from '../../../../components/common/CustomButtons/Button'
import Criteria from '../../common/Criteria'
import { QuoteBanner2 } from '../../../../components/common/QuoteBanner2';
import { Text } from '../../../../components/common/LanguageProvider';
import LoadingSpinnerScreen from '../../../../components/common/loadingScreen';
import RefundUpdateModal from '../../admin/Refund/RefundUpdateModal'
// Viewer
import PDFViewer from "../../../../components/common/PDFViewer/AllPageViewer";
import ImageViewer from "../../../../components/common/ImageViewer";
import { download } from '../../../../functionalities/downloadFile';
// icon
import DescriptionIcon from '@material-ui/icons/DescriptionOutlined';
import GetAppIcon from '@material-ui/icons/GetApp'
import { SiMinutemailer } from "react-icons/si";
import PersonIcon from '@mui/icons-material/Person';
import ArticleIcon from '@mui/icons-material/Article';
import EditIcon from '@material-ui/icons/Edit';

// logos
import allianzLogo from '../../../../assets/imgs/logo/allianz-logo.png'
import tugoLogo from '../../../../assets/imgs/logo/tugo-logo.png'
import gmsLogo from '../../../../assets/imgs/logo/gms-logo.png'
import blueCrossLogo from '../../../../assets/imgs/logo/blueCross-logo.png'
import travelanceLogo from '../../../../assets/imgs/logo/travelance-logo.png'

//style
import dashboardStyles from '../../../../assets/jss/styles/dashboardStyle';

// import IconButton from '@material-ui/core/IconButton';


const useStyles = makeStyles(dashboardStyles)
//
const formType = [
  { from: 'P', name: 'Public'},
  { from: 'V', name: 'Vendor'},
  { from: 'Z', name :'ZCRM'}
]


export default function SearchRefund(props) { 
    const { vendorID, user } = props;

  const classes = useStyles();

  const dispatch = useDispatch();
  const refunds = useSelector(state => state.refundReducer.refunds)
  const file = useSelector(state => state.s3Reducer.file)
  const loading = useSelector(state => state.s3Reducer.loading)
  const error = useSelector(state => state.s3Reducer.error)
  const loadingRefundList = useSelector(state => state.refundReducer.loading)
  const sendEmailResult = useSelector(state => state.refundReducer.sendEmailResult)
  const sendEmailLoading = useSelector(state => state.s3Reducer.sendEmailLoading)
  const sendEmailError = useSelector(state => state.s3Reducer.sendEmailError)
  // run useEffect only once when first render
  const [isLoaded, setIsLoaded] = useState(false)

  // criteria
  const [criteriaData, setCriteriaData] = useState({
    fromDate: new Date().toISOString().substring(0,8)+'01',
    toDate: new Date().toISOString().substring(0,10)
  })
  
  //
  const [selectedRows, setSelectedRows] = useState()
  const [currntPage, setCurrntPage] = useState(0)
  const [rowsSelected, setRowsSelected] = useState([])

  const [sentEmail, setSentEmail] = useState(true)
  const [alterOpen, setAlterOpen] = useState(false)

  // update refund modal
  const [updateOpen, setUpdateOpen] = useState(false);
  const [updateData, setUpdateData] = useState([]);

  // Viewer
  const [openViewer, setOpenViewer] = useState(false);
  // PDF Viewer
  const [filePDF, setFilePDF] = useState([])
  const [viewType, setViewType] = useState('')

  const getSearchResult = useCallback(() => {
    dispatch(getRefundRequest({fr:criteriaData.fromDate,to:criteriaData.toDate, vendor_id:vendorID}))
  }, [dispatch, criteriaData.fromDate, criteriaData.toDate, vendorID]);

  // run useEffect only once when first render
  useEffect(() => {
    if(isLoaded === false){
      getSearchResult()
      setIsLoaded(true)
    }
  }, [getSearchResult, isLoaded]);


  function getDocumentFromS3(viewType,file_name, selectedRow){
    setSelectedRows(selectedRow)
    setFilePDF(file_name.split('/'))
    setViewType(viewType)
    setOpenViewer(true)
    dispatch(getFileFromS3({type:file_name.split('/')[0], fileName:file_name.split('/')[1]})) 
  }

  function sendEmailProvider(value, attachFiles){
    const data = { insured: value,
                    attachments: attachFiles
                  }
    setSentEmail(true)              
    setAlterOpen(true)
    dispatch(sendEmailToProvider(data))
  }

  // update refund
  function updateRefund(refundID){
    setUpdateData(refunds.filter(d => d.refund_id === refundID ))
    setUpdateOpen(true)
  };

  // re get application list after updating
  function handleConfirm(resultMessage){
    // console.log("pop up update message ")
    if (resultMessage === 'success'){
      getSearchResult()
    }

  };

  // const refundsData = []
  const refundsData = refunds && refunds.length > 0 
        ? refunds.map(row => {
              const updatedRow = {
                ...row,
                refundID: row.refund_id,
                vendorName: row.vendor_name,
                sourceFrom: formType.filter(f=>f.from===row.source_from).map(form=>form.name)[0],
                confirmationNo: row.confirmation_no,
                insuranceCompany: row.insurance_company,
                policyNo: row.policy_number,
                requestDate: dateFormat(new Date(row.request_date+'T00:00:00')),
                insuredName: row.firstname + ' ' +row.lastname,
                birthdate: dateFormat(new Date(row.birthdate+'T00:00:00')),
                files: row.documents_url,      
                status :(row.refund_date&&row.refund_amount>0)?'Refunded':(row.refunded?row.refunded:row.status),
                refundDate: row.refund_date?dateFormat(new Date(row.refund_date+'T00:00:00')):null,
                emailedProvider: row.email_provider
              };
              return updatedRow;
          })
        :[];

  // Column definitions
  function getColumns(){
    const columns=[
        {name: "refundID", label: "Request #", 
          options: {filter: false, display: false, download: false, print: false}
        },
        {name: "vendorName", label: "vendor", 
          options: {filter: vendorID==='*'?true:false, display: vendorID==='*'?true:false}
        },
        {name: "sourceFrom", label: "Source", 
          options: {filter: vendorID==='*'?true:false, display: vendorID==='*'?true:false}
        },
        {name: "requestDate", label: Text({tid:'Dashboard.Table.RequestDate'}),
          options: {filter: false}
        },        
        {name: "insuranceCompany", label: 'company',
          options: { display: false}
        },
        {name: "policyNo", label: Text({tid:'Quote.PolicyNumber'}),
          options: {filter: false,
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <>
                {(tableMeta.rowData[4]==='Tugo' || tableMeta.rowData[4]==='Allianz'
                  || tableMeta.rowData[4]==='GMS'|| tableMeta.rowData[4]==='BlueCross' || tableMeta.rowData[4]==='Travelance') 
                  ?                    
                    <img
                      src={tableMeta.rowData[4] === 'Tugo'
                            ? tugoLogo : tableMeta.rowData[4] === 'Allianz'
                              ? allianzLogo : tableMeta.rowData[4] === 'GMS'
                                ? gmsLogo: tableMeta.rowData[4] === 'BlueCross' ? blueCrossLogo : travelanceLogo}
                      // src={logo}
                      style={{ width: 20, height: 20}}
                      alt='logo'
                    />
                  : tableMeta.rowData[4]
                } 
                {' '}
                {value}
              </>
              );
            }
          }
        },
        {name: "insuredName", label: Text({tid:'Dashboard.Table.Name'}),
          options: {filter: false}
        },
        {name: "birthdate", label: Text({tid:'Dashboard.Table.DateOfBirth'}),
          options: {filter: false}
        },       
        {name: "email", label: Text({tid:'Quote.Email'}), 
          options: {filter: false}
        }, 
        {name: "refundDate", label: Text({tid:'Dashboard.Table.RefundDate'}),
          options: {filter: false}
        },        
        {name: "status", label: Text({tid:'Dashboard.Table.Status'}),
        },   
        {name: "files", label: 'files',
            options: {filter: false,  display: false, download: false, print: false,},
        },   
        {name: "emailedProvider", label: 'Email to provider',
          options: { filter: false,
                      display: vendorID==='*'?true:false,
                      sort: false, empty: true, download: false, print: false,
            customHeadRender: (columnMeta) => {
              return(
                <TableCell key={columnMeta.label} style={{ fontSize:'12px', fontWeight:'600'}}>
                  {columnMeta.label}
                </TableCell>
              );
            },                            
            customBodyRender: (value, tableMeta) => {
              // console.log('tableMeta.rowData',tableMeta.rowData)
              return (
                  <IconButton aria-label="edit" variant="outlined" color="primary" 
                      // disabled = {value}
                      disabled = {value===false?(!tableMeta.rowData[9]?false:true):true}
                      onClick={() => {
                        setRowsSelected(tableMeta.currentTableData.filter(f=>f.data[3]=== tableMeta.rowData[3] && f.data[5]=== tableMeta.rowData[5]).map(i=>i.index))
                      }}
                  >
                    <SiMinutemailer/>
                  </IconButton>
              );
            }
          }
        },  
        {name: "update_refund", label: 'Update refund',
          options: { filter: false,
                      display: vendorID==='*'?true:false,
                      sort: false, empty: true, download: false, print: false,
            customHeadRender: (columnMeta) => {
              return(
                <TableCell key={columnMeta.label} style={{ fontSize:'12px', fontWeight:'600'}}>
                  {columnMeta.label}
                </TableCell>
              );
            },                            
            customBodyRender: (value, tableMeta) => {
              return (
                  <IconButton aria-label="edit" variant="outlined" color="primary" 
                      disabled = {tableMeta.rowData[10]==='Requested'?false:true}
                      onClick={() => {
                        setSelectedRows(tableMeta.rowIndex)  
                        updateRefund(tableMeta.rowData[0])
                      }}
                  >
                    <EditIcon/>
                  </IconButton>
              );
            }
          }
        },
      ]
    return (columns)
  }

  const columns = getColumns()

  const options = {
    filter: true,
    filterType: "dropdown",
    selectableRows: 'multiple', //'single', //'none',  //'multiple',
    selectableRowsHideCheckboxes: true,
    // responsive: "vertical",
    responsive: "standard",
    rowStyle: {height: 30},
    viewColumns: false,
    // download: true,
    // print: true,  
    page: currntPage,
    rowsSelected: rowsSelected,
    onChangePage (currentPage) {
      setCurrntPage(currentPage);
    },  
    customToolbarSelect: (selectedRows,rowData) => {
      const selectedData = rowData.filter(f => selectedRows.data.map(i=>i.dataIndex).includes(f.dataIndex))

      var fileList = []
      selectedData.map(i=>i.data[11]?i.data[11].map(d=>fileList.push({type: d.split('/')[0], fileName:d.split('/')[1]})):'')
      
      var obj = Object.create(null)
      var attachFiles = []
      // group by type,fileName
      fileList.forEach(function (o) {
        var key = ['type','fileName'].map(function (k) { return o[k]; }).join('|');
        if (!obj[key]) {
            obj[key] = { type: o.type, fileName: o.fileName};
            attachFiles.push(obj[key]);
        }
    });

      return(
        <Grid container>
          <Grid item xs container direction="column" spacing={0}>
            <Grid item xs container spacing={0}>
              <Grid item xs={2}>
                <label className={classes.inputLabel}>To Provider</label>
                <Typography>            
                  {selectedData[0].data[4]}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <label className={classes.inputLabel}>Insured</label>
                {selectedData.map(d => 
                  <Typography key={d.data[6]}>
                      {d.data[6]}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <label className={classes.inputLabel}>Attachments</label>
                {attachFiles.map((f) => 
                  <Typography key={f.fileName}>
                      {f.fileName}
                  </Typography>
                )}
              </Grid>
            </Grid>

          </Grid>
          {!(sentEmail && sendEmailResult && sendEmailResult.status === 'success') && 
            <Grid item xs={3} >
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: '2vh' }}
                disabled={true} // temporary
                onClick={()=>{
                  var data = refunds.filter(r => selectedData.map(i=>i.data[0]).includes(r.refund_id))
                  sendEmailProvider(data, attachFiles)
                }}
              >
                Send Email
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: '1vh', marginRight: '2vh' }}
                onClick={()=>{
                  setSentEmail(false)   
                  setAlterOpen(false)
                  setRowsSelected([])
                }}
              >
                Cancel
              </Button>
            </Grid>
          }
          {!sendEmailError && !sendEmailLoading && sendEmailResult.status && alterOpen && (
              <Grid item xs={12} style={{marginRight:'2vh'}}>
                <Alert severity={sendEmailResult.status}
                        onClose={() => {
                            setSentEmail(false)   
                            setAlterOpen(false)
                            setRowsSelected([])
                            if (sendEmailResult.status === 'success'){getSearchResult()}
                        }}
                >     
                  <AlertTitle>{sendEmailResult.status}</AlertTitle>
                  {sendEmailResult.message }
                </Alert>
              </Grid>
          )}
        </Grid>
        
      )
    },  
    expandableRows: true,
    expandableRowsOnClick: true,
    // onRowClick: (rowData) => {
    //   console.log(rowData);
    // },
    rowsExpanded: [selectedRows],
    renderExpandableRow: (rowData, rowMeta) => {      
      const clickedData = (refunds.filter(d => d.refund_id === rowData[0]))[0]
      // console.log(clickedData)
      return (
        clickedData &&
        <tr>
        <td colSpan={12}>
          <Grid container spacing={1} justifyContent="center">
              {/* Detail */}
              <Grid item container style={{ border:'1px solid #ddd', margin:'1vh' }}>
                    <Grid item container style={{ background:'#efefef', padding:'1vh', fontWeight:'700' }}>
                      <PersonIcon/> {clickedData.lastname}, {clickedData.firstname}
                    </Grid>             
                    <Grid item container style={{ padding:'1vh', fontSize:'12px', fontWeight:'500' }}>
                      <Grid item container xs={12} sm={12} md={4} lg={4}>
                        <Grid item xs={5}>
                          <span style={{ color:'#666' }}><Text tid={'Quote.FullName'} /></span>
                        </Grid>
                        <Grid item xs={7}>
                          <span style={{ fontWeight:'700' }}>{clickedData.lastname}, {clickedData.firstname}</span>
                        </Grid>
                      </Grid>
                      <Grid item container xs={12} sm={12} md={4} lg={4}>
                        <Grid item xs={5}>
                          <span style={{ color:'#666' }}><Text tid={'Quote.BirthDate'} /></span>
                        </Grid>
                        <Grid item xs={7}>
                          <span style={{ fontWeight:'700' }}>{clickedData.birthdate}</span>
                        </Grid>
                      </Grid>
                      <Grid item container xs={12} sm={12} md={4} lg={4}>
                        <Grid item xs={5}>
                          <span style={{ color:'#666' }}><Text tid={'Quote.Step.TripPurpose'} /></span>
                        </Grid>
                        <Grid item xs={7}>
                          <span style={{ fontWeight:'700' }}>{clickedData.insurance_type}</span>
                        </Grid>
                      </Grid>
                    </Grid> 

                    {/* Insurance */}
                    <Grid item container style={{ border:'1px solid #ddd', margin:'1vh', background:'#DAE3F3' }}>
                        <Grid item container style={{ background:'#efefef', padding:'1vh' }}>
                          <Grid item xs={12} sm={12} md={8}>
                            <ArticleIcon/> {`${clickedData.policy_number}`} 
                          </Grid>
                          <Grid item xs={12} sm={12} md={4} style={{ textAlign:'right' }}>
                            <span className={classes.inputValue} style={{ color:"red", fontSize:'14px' }}>{clickedData.refunded}{clickedData.refunded&&clickedData.refund_amount>0?' Refunded': null}</span>
                          </Grid>
                        </Grid>
                        {/*  refund requested reason */}
                        <Grid item container style={{ padding:'1vh', fontSize:'12px', fontWeight:'500' }}>
                          <Grid item container xs={12} sm={12} md={4} lg={3}>
                            <Grid item xs={4}>
                              <span style={{ color:'#666' }}><Text tid={'Quote.Refund.Reason.Select.Label'} /></span>
                            </Grid>
                            <Grid item xs={8}>
                              <span style={{ fontWeight:'700' }}>{clickedData.reason}</span>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* Document */}
                        {clickedData.documents_url &&
                            <Grid item container xs={12} style={{ padding:'1vh', fontSize:'12px', fontWeight:'500', background:'#fff', margin:'1vh' }}>
                              <Grid item xs={12}>
                                <span style={{ color:'#666' }}>Documents</span>
                              </Grid>
                              <Grid item xs={12}>
                              {/* <span className={classes.inputValue}>{clickedData.documents_url.split('-')[2]}</span>      */}
                                <span className={classes.inputValue}>
                                  {clickedData.documents_url && clickedData.documents_url.map((item) => (
                                    <div key={item} className={classes.textMargin}>

                                      {/* View */}
                                      <IconButton aria-label="view" color="primary"
                                        style={{ borderRadius:'0'}} 
                                        onClick={() => {
                                          getDocumentFromS3('view', item, rowMeta.dataIndex )
                                        }}
                                        >
                                          <span style={{ fontSize:'10px', fontWeight:'700', padding:'5px 10px', border:'1px solid'  }}>
                                            <DescriptionIcon style={{ height:'18px' }} /> 
                                            <Text tid={'Vendor.Application.ViewDeclaration'} />
                                          </span>  
                                      </IconButton>

                                      {/* Download */}
                                      <IconButton aria-label="view" color="primary"
                                        style={{ borderRadius:'0'}} 
                                        // onClick={handleDownload}
                                        onClick={() => {
                                          getDocumentFromS3('download', item, rowMeta.dataIndex )
                                        }}
                                        >
                                          <span style={{ fontSize:'10px', fontWeight:'700', padding:'5px 10px', border:'1px solid' }}>
                                            <GetAppIcon style={{ height:'18px' }}/> <Text tid={'Vendor.Application.DownloadDeclaration'} />
                                          </span>   
                                      </IconButton> 
                                      {item?item.split('/')[1]:null}
                                    </div>
                                  ))}
                                </span>  
                              </Grid>   
                          </Grid> 
                        }
                        {/*  Refuned Detail */}
                        {clickedData.refunded !=='Requested' && clickedData.refund_date &&
                          <Grid item container style={{ padding:'1vh', fontSize:'12px', fontWeight:'500' }}>
                            <Grid item container xs={12} sm={12} md={4} lg={3}>
                              <Grid item xs={4}>
                                <span style={{ color:'#666' }}><Text tid={'Quote.Refund.Refund.Amount'} /></span>
                              </Grid>
                              <Grid item xs={8}>
                                <span style={{ fontWeight:'700', color:"red" }}>{clickedData.refund_amount>0?`$${clickedData.refund_amount}`:'$0'}</span>
                              </Grid>
                            </Grid>
                            <Grid item container xs={12} sm={12} md={4} lg={3}>
                              <Grid item xs={4}>
                                <span style={{ color:'#666' }}>Admin fee</span>
                              </Grid>
                              <Grid item xs={8}>
                              <span style={{ fontWeight:'700', color:"red" }}>{clickedData.admin_fee?`$${clickedData.admin_fee}`:'$0'}</span>
                              </Grid>
                            </Grid>
                            <Grid item container xs={12} sm={12} md={4} lg={3}>
                              <Grid item xs={4}>
                                <span style={{ color:'#666' }}>Discounted amount</span>
                              </Grid>
                              <Grid item xs={8}>
                              <span style={{ fontWeight:'700', color:"red" }}>{clickedData.discounted_amount?`$${clickedData.discounted_amount}`:'$0'}</span>
                              </Grid>
                            </Grid>
                            <Grid item container xs={12} sm={12} md={4} lg={3}>
                              <Grid item xs={4}>
                                <span style={{ color:'#666' }}>Actual amount sent</span>
                              </Grid>
                              <Grid item xs={8}>
                                <span style={{ fontWeight:'700', color:"red" }}>{clickedData.actual_refund_amount_sent>0? `$${clickedData.actual_refund_amount_sent}`:'$0'}</span>
                                {clickedData.actual_refund_amount_sent > 0?` paid through ${clickedData.refund_payment_method}`:null}
                              </Grid>
                            </Grid>

                            <Grid item container xs={12} sm={12} md={4} lg={3}>
                              <Grid item xs={4}>
                                <span style={{ color:'#666' }}><Text tid={'Quote.Refund.Refund.CompletedDate'} /></span>
                              </Grid>
                              <Grid item xs={8}>
                              <span style={{ fontWeight:'700' }}>{clickedData.refund_date}</span>
                              </Grid>
                            </Grid>
                            {clickedData.refund_payment_method === 'E-transfer'&&
                              <>
                                <Grid item container xs={12} sm={12} md={4} lg={3}>
                                  <Grid item xs={4}>
                                    <span style={{ color:'#666' }}>E-transfer refunded date</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                  <span style={{ fontWeight:'700' }}>{clickedData.etransfer_refund_date}</span>
                                  </Grid>
                                </Grid>
                                <Grid item container xs={12} sm={12} md={4} lg={3}>
                                  <Grid item xs={4}>
                                    <span style={{ color:'#666' }}>E-transfer Recipient</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                  <span style={{ fontWeight:'700' }}>{clickedData.etransfer_recipient}</span>
                                  </Grid>
                                </Grid>
                                <Grid item container xs={12} sm={12} md={4} lg={3}>
                                  <Grid item xs={4}>
                                    <span style={{ color:'#666' }}>E-mail for E-transfer</span>
                                  </Grid>
                                  <Grid item xs={8}>
                                  <span style={{ fontWeight:'700' }}>{clickedData.etransfer_email}</span>
                                  </Grid>
                                </Grid>
                              </>
                            }

                          </Grid>
                        }
                    </Grid>

              </Grid>
          </Grid>

          
          
        </td>
        </tr>

      );
    },
  };


  return (
    <Grid container justifyContent='center'>
      <Grid item container style={{ marginTop:'-37px' }}>         
        <QuoteBanner2 title={'Dashboard.Refund'} subTitle={'Dashboard.Refunds.SubTitle'} links={[]}/>
      </Grid>  

      <Grid item container xs={12} sm={12} justifyContent='center' style={{ marginBottom:'5vh' }}>
        <Grid item xs={12} style={{ margin:'3vh 5vh' }}>
          {loadingRefundList
              ? 
                <LoadingSpinnerScreen/>
              :
                <MUIDataTable
                  title= {
                    <div>
                      <Grid item container style={{ margin:'2vh 0' }}>
                        <Typography className={classes.tableTitle}>
                          <ArticleIcon style={{ marginRight:'5px'}} />
                          <Text tid={'Dashboard.Refunds.List.Title'} />
                        </Typography>
                      </Grid>
                      <Criteria
                        criteriaData = {criteriaData}
                        setCriteriaData = {setCriteriaData}
                        onClick ={getSearchResult}
                      />
                    </div>    
                    }
                  data={refundsData}
                  columns={columns}
                  options={options}
                />
            }
          
          {/* update refund  */}
          {updateData[0] &&
            <RefundUpdateModal
              updateData={updateData}
              user={user}
              open={updateOpen}
              setOpen={setUpdateOpen}
              onConfirm={handleConfirm}
            /> 
          }  
        
          {/* pdf viewer  */}
          {!error && !loading && file && file.Body && openViewer === true &&(
            viewType === 'view' 
            ?
            ( file.ContentType === 'application/pdf'
              ?
                <PDFViewer
                  title={'Refund'}
                  pdf={new Uint8Array(file.Body.data).buffer} 
                  openPDFViewer={openViewer}
                  setOpenPDFViewer={setOpenViewer}
                />
                :
                <ImageViewer
                  title={'Refund'}
                  file={file} 
                  openViewer={openViewer}
                  setOpenViewer={setOpenViewer}
                />
              )
            :
            <>
              {setOpenViewer(download(new Blob([new Uint8Array(file.Body.data).buffer], {type: 'application/pdf'}), filePDF[1]))}
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
    
  )
}


